import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/circle-info-icon.png'


const _hoisted_1 = { class: "new-mobile-section" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "title-new-mobile" }, "กรอกเบอร์โทรศัพท์มือถือใหม่", -1)
const _hoisted_4 = { class: "title-current-mobile-no" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "content-new-mobile" }
const _hoisted_7 = { class: "content-notification" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "notification-snackbar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "notification-icon",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "notification-info" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "notification-header" }, "สำหรับผู้ที่ผูกบัญชีทรูมันนี่"),
    /*#__PURE__*/_createElementVNode("span", { class: "notification-description" }, "ระบบจะยกเลิกการผูกบัญชีหลังแก้ไข คุณสามารถผูกบัญชีได้อีกครั้งด้วยเบอร์โทรศัพท์มือถือใหม่")
  ])
], -1)
const _hoisted_9 = { class: "content-btn" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("ต่อไป")

export function render(_ctx, _cache) {
  const _component_q_input = _resolveComponent("q-input")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_form = _resolveComponent("q-form")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, "เบอร์โทรศัพท์ปัจจุบัน: " + _toDisplayString(_ctx.mobileNumber), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_q_form, {
        class: "content-form",
        greedy: "",
        onSubmit: _ctx.submitForm
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_q_input, {
              outlined: "",
              type: "tel",
              modelValue: _ctx.newMobileNumber,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = $event => ((_ctx.newMobileNumber) = $event)),
                _cache[1] || (_cache[1] = (val) => _ctx.onChangeNewMobileNumber(val, _ctx.$refs))
              ],
              ref: "newMobileNumberInput",
              label: "เบอร์โทรศัพท์มือถือใหม่",
              hint: "ตัวอย่าง: 0991234567",
              "no-error-icon": "",
              "hide-bottom-space": "",
              clearable: "",
              maxlength: "10",
              autofocus: "",
              rules: [(val) => _ctx.onRulesNewMobileNumber(val)]
            }, null, 8, ["modelValue", "rules"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_q_btn, {
                class: "btn",
                unelevated: "",
                type: "submit",
                disable: !_ctx.isSubmit
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["disable"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}